require("./profileTypesService");
require("./registrationService");
require("../shared/dobSelectorService");
require("../fhApp/currentUser/currentUser");

angular.module('app.registration.registrationController', [
  'app.registration.profileTypesService',
  'app.registration.registrationService',
  'app.shared.dobSelectorService',
  'app.currentUser',
])
  .controller('app.registration.registrationController', [
    '$scope',
    'app.registration.profileTypesService',
    'app.registration.registrationService',
    'app.shared.dobSelectorService',
    'currentUser',
    '$stateParams',
    function ($scope, profileTypes, registration, dobSelector, currentUser, $stateParams) {
      "use strict";

      let reg_defaults = {
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        mob: dobSelector.new(),
        gender: null,
        phone: null,
        profile_type: null,
        username: null,
      };

      $scope.loginRedirect = $stateParams.loginRedirect;
      $scope.loginRedirectParams = $stateParams.loginRedirectParams;
      $scope.passwordPass = false;
      $scope.showPassword = false;
      $scope.passwordType = 'password';

      let init = function () {
        profileTypes.retrieve();
      };

      let setError = function (field, message) {
        if (message) {
          $scope.errors[field] = message;
        }
        else {
          delete $scope.errors[field];
        }
      };

      let hasError = function () {
        for (let i in $scope.errors) {
          if ($scope.errors.hasOwnProperty(i)) {
            if ($scope.errors[i]) {
              return true;
            }
          }
        }
        return false;
      };

      let clearErrors = function () {
        for (let i in $scope.errors) {
          if ($scope.errors.hasOwnProperty(i)) {
            delete $scope.errors[i];
          }
        }
        return false;
      };

      let validateForm = function (form) {
        let reg_info = $scope.reg_info;

        clearErrors();

        if (form) {
          let elements = form.elements;

          for (let i in elements) {
            if (elements.hasOwnProperty(i)) {
              let el = elements[i];
              if (typeof el.value !== 'undefined') {
                let is_valid = el.checkValidity();
                if (!is_valid) {
                  setError(el.dataset.field, el.validationMessage);
                }
              }
            }
          }
          if (hasError()) {
            return false;
          }
        }

        if (reg_info.email !== $scope.email_confirm) {
          setError('email_confirm', 'Your email addresses do not match');
        }

        if (reg_info.password === $scope.confirm_password) {
          if (!$scope.passwordPass) {
            setError('password', 'Your password is too easy to guess');
          }
        }
        else {
          setError('password_confirm', 'Passwords do not match');
        }

        if (reg_info.username.length < 6) {
          setError('username', 'Username must contain at least 6 characters');
        }

        return !hasError();
      };

      let processRegistrationRequest = function (data) {
        if (data.messages) {
          setError('messages', data.messages);
        }

        if (data.error) {
          alert(data.error);
        }
        else {
          $scope.registration_successful = true;
          $scope.reg_info = angular.copy(reg_defaults);
        }
      };


      $scope.reg_info = angular.copy(reg_defaults);
      $scope.email_confirm = null;
      $scope.confirm_password = null;
      $scope.profileTypes = profileTypes;
      $scope.errors = {};
      $scope.registration_successful = false;

      $scope.register = function (event) {
        if (validateForm(event.target)) {
          let reg_info = {
            first_name: $scope.reg_info.first_name,
            last_name: $scope.reg_info.last_name,
            email: $scope.reg_info.email,
            password: $scope.reg_info.password,
            mob: $scope.reg_info.mob.getDate().format('YYYY-MM'),
            gender: $scope.reg_info.gender,
            phone: $scope.reg_info.phone,
            profile_type: $scope.reg_info.profile_type,
            username: $scope.reg_info.username,
          };
          let options = {plan_code: $stateParams.plan_code, team_id: $stateParams.team};
          registration.register({user: reg_info, options: options}).then(
            /**
             * @param {HttpResponse} response
             */
            function (response) {
              processRegistrationRequest(response.data);
            },
            /**
             * @param {HttpResponse} response
             */
            function (response) {
              processRegistrationRequest(response.data);
            }
          );
        }
      };

      $scope.checkUsername = function () {
        currentUser.checkUsername($scope.reg_info.username)
          .then(function (response) {
            if (response.data) {
              $scope.errors.username = response.data.message;
            }
            else {
              $scope.errors.username = null;
            }
          });
      };

      $scope.showPasswordClick = () => {
        $scope.showPassword = !$scope.showPassword;
         if($scope.showPassword) {
           $scope.passwordType = "text";
         } else {
           $scope.passwordType = "password";
         }
      };

      init();
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/registration/registrationController.js